module.exports = __webpack_public_path__ + "1793882494189/fonts/WorkSans-Medium.e0522d9.woff";